import { render, staticRenderFns } from "./make-paydoc.vue?vue&type=template&id=48637f48&"
import script from "./make-paydoc.vue?vue&type=script&lang=js&"
export * from "./make-paydoc.vue?vue&type=script&lang=js&"
import style0 from "./make-paydoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "make-paydoc.vue"
export default component.exports